// Shared slide content used by both the standalone /walkthrough page and the Dashboard modal

const NAVY   = '#0a2540';
const ORANGE = '#F37428';
const BLUE   = '#2563eb';

function AppShell({ children, activeNav = 'dashboard' }) {
  const navItems = [
    { id: 'dashboard', label: 'Dashboard',   icon: '▦' },
    { id: 'upload',    label: 'Upload File', icon: '↑' },
    { id: 'master',    label: 'Master File', icon: '◆' },
    { id: 'billing',   label: 'Billing',     icon: '▬' },
    { id: 'team',      label: 'Team',        icon: '◉' },
  ];
  return (
    <div style={{ display: 'flex', height: '100%', fontSize: 11, background: '#f1f5f9' }}>
      <div style={{ width: 148, background: '#fff', flexShrink: 0, display: 'flex', flexDirection: 'column', borderRight: '1px solid #e2e8f0' }}>
        <div style={{ padding: '14px 16px 12px', borderBottom: '1px solid #f1f5f9' }}>
          <div style={{ fontWeight: 900, fontSize: 13, letterSpacing: -0.4, color: '#0f172a' }}>
            MASTERFILE<span style={{ color: ORANGE }}>AI</span>
          </div>
        </div>
        <div style={{ flex: 1, paddingTop: 8 }}>
          {navItems.map(n => (
            <div key={n.id} style={{
              display: 'flex', alignItems: 'center', gap: 8, padding: '7px 14px',
              background: activeNav === n.id ? '#eff6ff' : 'transparent',
              borderLeft: activeNav === n.id ? `3px solid ${BLUE}` : '3px solid transparent',
              color: activeNav === n.id ? BLUE : '#64748b',
              fontSize: 11, fontWeight: activeNav === n.id ? 700 : 400,
            }}>
              <span style={{ fontSize: 11, opacity: 0.7 }}>{n.icon}</span> {n.label}
            </div>
          ))}
        </div>
        <div style={{ padding: '10px 14px', borderTop: '1px solid #f1f5f9' }}>
          <div style={{ fontSize: 9, color: '#94a3b8' }}>you@company.com</div>
        </div>
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: '#f8fafc' }}>
        <div style={{ flex: 1, overflow: 'hidden' }}>{children}</div>
      </div>
    </div>
  );
}

function StatCard({ value, label, color = NAVY }) {
  return (
    <div style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 14px' }}>
      <div style={{ fontWeight: 900, fontSize: 22, color, marginBottom: 2 }}>{value}</div>
      <div style={{ fontSize: 9, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.8 }}>{label}</div>
    </div>
  );
}

function StatusPill({ status }) {
  const map = { complete: ['#10b981','COMPLETE'], processing: [ORANGE,'PROCESSING'], uploaded: [BLUE,'UPLOADED'] };
  const [color, label] = map[status] || [BLUE, status];
  return <span style={{ background: `${color}18`, color, borderRadius: 4, padding: '2px 7px', fontSize: 8, fontWeight: 800, letterSpacing: 0.5 }}>{label}</span>;
}

function BarRow({ label, value, pct, color = BLUE }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 9 }}>
      <div style={{ width: 160, fontSize: 9.5, color: '#475569', flexShrink: 0 }}>{label}</div>
      <div style={{ flex: 1, height: 8, background: '#f1f5f9', borderRadius: 4, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 4 }} />
      </div>
      <div style={{ width: 36, fontWeight: 700, fontSize: 9.5, color: '#0f172a', textAlign: 'right' }}>{value}</div>
      <div style={{ width: 28, fontSize: 9, color: '#94a3b8', textAlign: 'right' }}>{pct}%</div>
    </div>
  );
}

function MockWelcome() {
  const features = [
    { icon: '🏢', label: 'Company Names Cleaned' },
    { icon: '📍', label: 'Addresses Standardized' },
    { icon: '🌐', label: 'Websites Found' },
    { icon: '🏭', label: 'NAICS Codes Assigned' },
    { icon: '📋', label: 'Business Profiles Built' },
    { icon: '👤', label: 'People Identified' },
    { icon: '🔗', label: 'Intercompany Links Flagged' },
  ];
  return (
    <div style={{ height: '100%', background: `linear-gradient(135deg, ${NAVY} 0%, #1a3a5c 100%)`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 20, padding: '32px 48px' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontWeight: 900, fontSize: 38, color: '#fff', letterSpacing: -1.5, marginBottom: 8 }}>MASTERFILE<span style={{ color: ORANGE }}>AI</span></div>
        <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14 }}>Vendor &amp; Customer Master Data Enrichment</div>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center', maxWidth: 520 }}>
        {features.map(f => (
          <div key={f.label} style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 20, padding: '6px 14px', color: 'rgba(255,255,255,0.85)', fontSize: 11, display: 'flex', alignItems: 'center', gap: 6 }}>
            <span>{f.icon}</span> {f.label}
          </div>
        ))}
      </div>
      <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 11, marginTop: 4, textAlign: 'center' }}>
        Upload your file · Choose your mode · Download enriched results
      </div>
    </div>
  );
}

function MockDashboard() {
  const jobs = [
    { id: 12, name: 'Vendors_2025_Q1.xlsx',    date: 'Mar 28, 2026', uploaded: '800',   enriched: '800',   status: 'complete' },
    { id: 11, name: 'Customers_US_Export.xlsx', date: 'Mar 14, 2026', uploaded: '2,341', enriched: '2,341', status: 'complete' },
    { id: 10, name: 'SAP_Vendors_EU.csv',       date: 'Feb 22, 2026', uploaded: '1,580', enriched: '1,580', status: 'complete' },
  ];
  return (
    <AppShell activeNav="dashboard">
      <div style={{ padding: '18px 22px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 16 }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 16, color: '#0f172a' }}>Dashboard</div>
            <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 2 }}>Your file cleaning jobs</div>
          </div>
          <button style={{ background: ORANGE, color: '#fff', border: 'none', borderRadius: 7, padding: '7px 14px', fontWeight: 700, fontSize: 10, cursor: 'pointer' }}>+ New upload</button>
        </div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 18 }}>
          <StatCard value="12" label="Total Jobs" color={BLUE} />
          <StatCard value="0" label="In Progress" color={NAVY} />
          <StatCard value="8,317" label="Records Uploaded" color={BLUE} />
          <StatCard value="7,891" label="Records Enriched" color={ORANGE} />
        </div>
        <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
          <div style={{ padding: '10px 14px', borderBottom: '1px solid #f1f5f9', fontWeight: 700, fontSize: 11, color: '#0f172a' }}>Recent jobs</div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 9.5 }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['ID','FILE NAME','UPLOADED','RECORDS UPLOADED','RECORDS ENRICHED','STATUS','ACTIONS'].map(h => (
                  <th key={h} style={{ padding: '6px 12px', color: '#94a3b8', fontWeight: 700, textAlign: 'left', letterSpacing: 0.5, fontSize: 8.5, borderBottom: '1px solid #f1f5f9' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {jobs.map((j, i) => (
                <tr key={j.id} style={{ borderBottom: i < jobs.length - 1 ? '1px solid #f8fafc' : 'none' }}>
                  <td style={{ padding: '7px 12px', color: '#94a3b8' }}>#{j.id}</td>
                  <td style={{ padding: '7px 12px', fontWeight: 600, color: '#0f172a' }}>{j.name}</td>
                  <td style={{ padding: '7px 12px', color: '#64748b' }}>{j.date}</td>
                  <td style={{ padding: '7px 12px', color: BLUE, fontWeight: 700 }}>{j.uploaded}</td>
                  <td style={{ padding: '7px 12px', color: BLUE, fontWeight: 700 }}>{j.enriched}</td>
                  <td style={{ padding: '7px 12px' }}><StatusPill status={j.status} /></td>
                  <td style={{ padding: '7px 12px' }}>
                    <span style={{ fontSize: 8.5, color: BLUE, fontWeight: 700, marginRight: 8, cursor: 'pointer' }}>View data</span>
                    <span style={{ fontSize: 8.5, background: ORANGE, color: '#fff', borderRadius: 4, padding: '2px 7px', fontWeight: 700, cursor: 'pointer' }}>Results →</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AppShell>
  );
}

function MockUpload() {
  return (
    <AppShell activeNav="upload">
      <div style={{ padding: '18px 22px' }}>
        <div style={{ fontWeight: 800, fontSize: 16, color: '#0f172a', marginBottom: 2 }}>Upload a file</div>
        <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 14 }}>Upload your vendor or customer master data to start cleaning.</div>
        <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 16px', marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 11, color: '#0f172a' }}>Start with the MasterFileAI template</div>
            <div style={{ fontSize: 9, color: '#94a3b8', marginTop: 2 }}>16 columns · 3 required · includes a sample row · works with Excel or any spreadsheet app</div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={{ background: ORANGE, color: '#fff', border: 'none', borderRadius: 6, padding: '6px 12px', fontWeight: 700, fontSize: 9, cursor: 'pointer' }}>↓ Download .xlsx</button>
            <button style={{ background: '#fff', color: '#475569', border: '1px solid #e2e8f0', borderRadius: 6, padding: '6px 12px', fontSize: 9, cursor: 'pointer' }}>📄 Technical Spec (PDF)</button>
          </div>
        </div>
        <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 16px', marginBottom: 12 }}>
          <div style={{ fontSize: 9, fontWeight: 800, color: BLUE, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>Required Columns</div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
            {['System Name', 'Vendor / Customer #', 'Vendor / Customer Name'].map(c => (
              <span key={c} style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 5, padding: '3px 10px', fontSize: 9.5, color: '#0f172a', fontWeight: 600 }}>{c}</span>
            ))}
          </div>
          <div style={{ fontSize: 9, fontWeight: 800, color: BLUE, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>File Requirements</div>
          {['.xlsx or .csv format, maximum 50 MB', 'Up to 50,000 rows per file', 'First 10 records always processed free — no credit card required'].map(r => (
            <div key={r} style={{ fontSize: 9, color: '#475569', marginBottom: 3 }}>• {r}</div>
          ))}
        </div>
        <div style={{ border: '2px dashed #cbd5e1', borderRadius: 10, padding: '22px', textAlign: 'center', background: '#fff', marginBottom: 12 }}>
          <div style={{ fontSize: 24, marginBottom: 6 }}>📁</div>
          <div style={{ fontWeight: 600, fontSize: 12, color: '#0f172a', marginBottom: 3 }}>Drag &amp; drop your file here</div>
          <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 10 }}>or click to browse</div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
            {['.xlsx','.csv'].map(e => <span key={e} style={{ background: '#f1f5f9', borderRadius: 5, padding: '3px 10px', fontSize: 9, color: '#64748b', fontWeight: 600 }}>{e}</span>)}
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button style={{ background: '#fff', color: '#475569', border: '1px solid #e2e8f0', borderRadius: 7, padding: '8px 16px', fontSize: 10, cursor: 'pointer' }}>Cancel</button>
          <button style={{ background: ORANGE, color: '#fff', border: 'none', borderRadius: 7, padding: '8px 16px', fontWeight: 700, fontSize: 10, cursor: 'pointer', opacity: 0.5 }}>Upload file →</button>
        </div>
        <div style={{ textAlign: 'center', fontSize: 9, color: '#94a3b8', marginTop: 8 }}>🎁 Your first 10 records are always free — no credit card needed to get started.</div>
      </div>
    </AppShell>
  );
}

function MockProcessMode() {
  return (
    <AppShell activeNav="upload">
      <div style={{ padding: '16px 22px' }}>
        <div style={{ fontWeight: 800, fontSize: 14, color: '#0f172a', marginBottom: 2 }}>Choose Processing Mode</div>
        <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 14 }}>Vendors_2025_Q1.xlsx · 800 records detected</div>
        <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
          <div style={{ flex: 1, border: `2px solid ${ORANGE}`, borderRadius: 12, padding: '16px', background: `${ORANGE}06` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <span style={{ fontSize: 22 }}>✨</span>
              <div style={{ width: 16, height: 16, borderRadius: '50%', background: ORANGE, border: `3px solid ${ORANGE}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ width: 5, height: 5, borderRadius: '50%', background: '#fff' }} />
              </div>
            </div>
            <div style={{ fontWeight: 800, fontSize: 12, color: '#0f172a', marginBottom: 5 }}>Enrich New Records</div>
            <div style={{ fontSize: 9.5, color: '#64748b', lineHeight: 1.6, marginBottom: 12 }}>Only processes records not previously enriched. Perfect for incremental loads — saves cost.</div>
            <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 10 }}>
              <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 2 }}>156 new records <span style={{ color: '#cbd5e1' }}>@ $0.49/rec</span></div>
              <div style={{ fontWeight: 900, fontSize: 18, color: ORANGE }}>$76.44</div>
            </div>
          </div>
          <div style={{ flex: 1, border: '2px solid #e2e8f0', borderRadius: 12, padding: '16px', background: '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <span style={{ fontSize: 22 }}>🔄</span>
              <div style={{ width: 16, height: 16, borderRadius: '50%', border: '2px solid #e2e8f0', background: '#fff' }} />
            </div>
            <div style={{ fontWeight: 800, fontSize: 12, color: '#0f172a', marginBottom: 5 }}>Re-enrich All</div>
            <div style={{ fontSize: 9.5, color: '#64748b', lineHeight: 1.6, marginBottom: 12 }}>Refreshes every record with the latest data. Ideal for a quarterly or annual full refresh.</div>
            <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 10 }}>
              <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 2 }}>800 records <span style={{ color: '#cbd5e1' }}>@ $0.49/rec</span></div>
              <div style={{ fontWeight: 900, fontSize: 18, color: NAVY }}>$392.00</div>
            </div>
          </div>
        </div>
        <button style={{ width: '100%', background: ORANGE, color: '#fff', border: 'none', borderRadius: 8, padding: '11px', fontWeight: 800, fontSize: 11, cursor: 'pointer' }}>Continue to Payment →</button>
      </div>
    </AppShell>
  );
}

function MockPayment() {
  const tiers = [
    { range: '1 – 1,000',       rate: '$0.49', active: true },
    { range: '1,001 – 2,500',   rate: '$0.39', active: false },
    { range: '2,501 – 5,000',   rate: '$0.29', active: false },
    { range: '5,001 – 20,000',  rate: '$0.25', active: false },
    { range: '20,001 – 50,000', rate: '$0.19', active: false },
  ];
  return (
    <AppShell activeNav="upload">
      <div style={{ padding: '16px 22px', display: 'flex', gap: 18 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 800, fontSize: 14, color: '#0f172a', marginBottom: 12 }}>Order Summary</div>
          <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px', marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, marginBottom: 6, color: '#475569' }}>
              <span>Re-enrich All — 800 records</span>
              <span style={{ fontWeight: 700, color: '#0f172a' }}>800 records</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, marginBottom: 10, color: '#475569' }}>
              <span>Rate</span><span style={{ fontWeight: 700, color: '#0f172a' }}>$0.49 / record</span>
            </div>
            <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 10, display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontWeight: 800, fontSize: 13, color: '#0f172a' }}>Total</span>
              <span style={{ fontWeight: 900, fontSize: 17, color: ORANGE }}>$392.00</span>
            </div>
          </div>
          <div style={{ fontSize: 9, fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 7 }}>Volume Pricing</div>
          <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, overflow: 'hidden' }}>
            {tiers.map((t, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 12px', background: t.active ? `${ORANGE}0a` : undefined, borderBottom: i < tiers.length - 1 ? '1px solid #f8fafc' : 'none' }}>
                <span style={{ fontSize: 9.5, color: t.active ? ORANGE : '#475569', fontWeight: t.active ? 700 : 400 }}>{t.range}</span>
                <span style={{ fontSize: 9.5, fontWeight: 700, color: t.active ? ORANGE : '#0f172a' }}>{t.rate}/rec</span>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 10, fontSize: 9, color: '#94a3b8' }}>Minimum charge: $250 per file</div>
        </div>
        <div style={{ width: 185 }}>
          <div style={{ fontWeight: 800, fontSize: 14, color: '#0f172a', marginBottom: 12 }}>Payment</div>
          <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px' }}>
            <div style={{ fontSize: 9, color: '#94a3b8', marginBottom: 4 }}>Card number</div>
            <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, padding: '7px 10px', fontSize: 10, color: '#cbd5e1', marginBottom: 10 }}>•••• •••• •••• 4242</div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 9, color: '#94a3b8', marginBottom: 4 }}>Expiry</div>
                <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, padding: '7px 10px', fontSize: 10, color: '#cbd5e1' }}>MM/YY</div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 9, color: '#94a3b8', marginBottom: 4 }}>CVC</div>
                <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, padding: '7px 10px', fontSize: 10, color: '#cbd5e1' }}>•••</div>
              </div>
            </div>
            <button style={{ width: '100%', background: ORANGE, color: '#fff', border: 'none', borderRadius: 7, padding: '9px', fontWeight: 800, fontSize: 11, cursor: 'pointer' }}>Pay $392.00</button>
            <div style={{ textAlign: 'center', fontSize: 8, color: '#94a3b8', marginTop: 8 }}>🔒 Secured by Stripe</div>
          </div>
          <div style={{ marginTop: 10, background: `${ORANGE}10`, border: `1px solid ${ORANGE}30`, borderRadius: 8, padding: '9px 10px' }}>
            <div style={{ fontSize: 9, fontWeight: 700, color: ORANGE }}>🎁 Free Trial</div>
            <div style={{ fontSize: 8.5, color: '#475569', marginTop: 3, lineHeight: 1.5 }}>First 10 records always free — no card needed</div>
          </div>
        </div>
      </div>
    </AppShell>
  );
}

function MockResults() {
  const rows = [
    { name: 'Acme Supply Co.',   addr: '123 Main St, Chicago IL 60601',       website: 'acmesupply.com',  naics: '423840' },
    { name: 'Global Parts Inc',  addr: '400 Commerce Blvd, Houston TX 77002', website: 'globalparts.com', naics: '423600' },
    { name: 'Schmidt GmbH',      addr: 'Hauptstraße 5, 10115 Berlin DE',       website: 'schmidt-gmbh.de', naics: '332710' },
    { name: 'Delta Systems LLC', addr: '88 Industrial Pkwy, Atlanta GA 30301', website: 'deltasys.com',    naics: '541512' },
  ];
  return (
    <AppShell activeNav="dashboard">
      <div style={{ padding: '14px 18px', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 14, color: '#0f172a' }}>Results — Vendors_2025_Q1.xlsx</div>
            <div style={{ fontSize: 9, color: '#94a3b8', marginTop: 2 }}>800 records enriched · Completed Mar 31, 2026</div>
          </div>
          <button style={{ background: ORANGE, color: '#fff', border: 'none', borderRadius: 7, padding: '7px 14px', fontWeight: 700, fontSize: 10 }}>↓ Download Results</button>
        </div>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          {[['800','Records Enriched',ORANGE],['764','Company Names Cleaned',BLUE],['728','Addresses Standardized',BLUE],['742','Websites Found',BLUE]].map(([n,l,c]) => (
            <div key={l} style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 10px' }}>
              <div style={{ fontWeight: 900, fontSize: 18, color: c }}>{n}</div>
              <div style={{ fontSize: 8, color: '#94a3b8', marginTop: 2, lineHeight: 1.3 }}>{l}</div>
            </div>
          ))}
        </div>
        <div style={{ flex: 1, background: '#fff', borderRadius: 8, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
          <table style={{ borderCollapse: 'collapse', fontSize: 9, width: '100%' }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                {['Vendor Name','Verified Address','Website','NAICS Code','Status'].map(h => (
                  <th key={h} style={{ padding: '7px 12px', borderBottom: '1px solid #e2e8f0', color: '#94a3b8', fontWeight: 700, textAlign: 'left', fontSize: 8.5, letterSpacing: 0.5, textTransform: 'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #f8fafc' }}>
                  <td style={{ padding: '7px 12px', fontWeight: 700, color: '#0f172a' }}>{r.name}</td>
                  <td style={{ padding: '7px 12px', color: '#475569' }}>{r.addr}</td>
                  <td style={{ padding: '7px 12px', color: BLUE }}>{r.website}</td>
                  <td style={{ padding: '7px 12px', color: '#475569', fontFamily: 'monospace' }}>{r.naics}</td>
                  <td style={{ padding: '7px 12px' }}><span style={{ background: '#10b98118', color: '#10b981', borderRadius: 4, padding: '2px 7px', fontSize: 8, fontWeight: 800 }}>✓ COMPLETE</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AppShell>
  );
}

function MockMasterFile() {
  return (
    <AppShell activeNav="master">
      <div style={{ padding: '14px 18px', height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 16, color: '#0f172a' }}>Master File</div>
            <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 2 }}>Your enriched vendor &amp; customer database</div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={{ background: '#fff', color: '#475569', border: '1px solid #e2e8f0', borderRadius: 7, padding: '6px 12px', fontSize: 9, fontWeight: 600 }}>↓ Download CSV</button>
            <button style={{ background: BLUE, color: '#fff', border: 'none', borderRadius: 7, padding: '6px 12px', fontSize: 9, fontWeight: 700 }}>View all records →</button>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
          {[['4,969','TOTAL RECORDS','4,969 enriched'],['2','SOURCE SYSTEMS','SAP, NetSuite'],['Mar 31, 2026','LAST ENRICHED','100% coverage']].map(([v,l,s]) => (
            <div key={l} style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 14px' }}>
              <div style={{ fontWeight: 900, fontSize: 18, color: '#0f172a', marginBottom: 3 }}>{v}</div>
              <div style={{ fontSize: 8.5, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 3 }}>{l}</div>
              <div style={{ fontSize: 8.5, color: '#64748b' }}>{s}</div>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 12, flex: 1, minHeight: 0 }}>
          <div style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px' }}>
            <div style={{ fontWeight: 700, fontSize: 12, color: '#0f172a', marginBottom: 3 }}>Enrichment Results</div>
            <div style={{ fontSize: 8.5, color: '#94a3b8', marginBottom: 12 }}>Click any row to drill into those records</div>
            <BarRow label="Company Names Cleaned"  value="4,631" pct={93} color="#6366f1" />
            <BarRow label="Addresses Standardized" value="3,876" pct={78} color="#06b6d4" />
            <BarRow label="Websites Found"          value="4,472" pct={90} color="#6366f1" />
            <BarRow label="NAICS Codes Assigned"    value="4,572" pct={92} color="#10b981" />
            <BarRow label="Business Profiles"       value="4,522" pct={91} color="#06b6d4" />
            <BarRow label="People Identified"       value="199"   pct={4}  color={ORANGE} />
            <BarRow label="Intercompany Flagged"    value="0"     pct={0}  color="#8b5cf6" />
          </div>
          <div style={{ width: 160, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontWeight: 700, fontSize: 12, color: '#0f172a', marginBottom: 14 }}>Quality Score</div>
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <div style={{ fontWeight: 900, fontSize: 38, color: '#10b981' }}>85%</div>
              <div style={{ fontSize: 9, color: '#94a3b8' }}>Avg profile confidence</div>
            </div>
            {[['Enrichment Rate','96%'],['Avg Domain Confidence','92%'],['Records Enriched','4,762 / 4,969'],['Errors','3']].map(([l,v]) => (
              <div key={l} style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #f8fafc', paddingTop: 6, paddingBottom: 2 }}>
                <span style={{ fontSize: 8.5, color: '#64748b' }}>{l}</span>
                <span style={{ fontSize: 8.5, fontWeight: 700, color: l === 'Errors' ? '#ef4444' : '#0f172a' }}>{v}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AppShell>
  );
}

function MockCTA() {
  return (
    <div style={{ height: '100%', background: `linear-gradient(135deg, ${NAVY} 0%, #1a3a5c 100%)`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 18 }}>
      <div style={{ fontWeight: 900, fontSize: 30, color: '#fff', textAlign: 'center', letterSpacing: -0.5 }}>
        You're all set!<br />Let's upload your first file.
      </div>
      <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, textAlign: 'center', maxWidth: 380, lineHeight: 1.7 }}>
        First 10 records free · No credit card · Results in minutes
      </div>
      <div style={{ display: 'flex', gap: 12, marginTop: 6 }}>
        <a href="/upload" style={{ background: ORANGE, color: '#fff', borderRadius: 9, padding: '13px 30px', fontWeight: 800, fontSize: 14, textDecoration: 'none' }}>
          Upload a File →
        </a>
        <a href="/master-file" style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', borderRadius: 9, padding: '13px 30px', fontWeight: 700, fontSize: 14, textDecoration: 'none', border: '1px solid rgba(255,255,255,0.2)' }}>
          View Master File
        </a>
      </div>
    </div>
  );
}

export const SLIDES = [
  {
    Mock: MockWelcome,
    title: 'Welcome to MasterFileAI',
    body: 'Your vendor and customer master data — cleaned, verified, and enriched automatically. This quick walkthrough shows you how it works.',
  },
  {
    Mock: MockDashboard,
    title: 'Step 1 — Your Dashboard',
    body: 'Your home base. See all jobs, record counts, and enrichment history at a glance. Click "+ New upload" whenever you\'re ready.',
  },
  {
    Mock: MockUpload,
    title: 'Step 2 — Upload your file',
    body: 'Download the template and fill in your vendor or customer data. Only 3 columns are required — but the more data you provide, the better the matching and enrichment we can do.',
  },
  {
    Mock: MockProcessMode,
    title: 'Step 3 — Choose your mode',
    body: '"Enrich New Records" only processes records we haven\'t seen before — great for incremental loads. "Re-enrich All" does a full refresh. Pricing adjusts automatically.',
  },
  {
    Mock: MockPayment,
    title: 'Step 4 — Review & pay',
    body: 'Volume discounts apply automatically. Your first 10 records are always free — no card needed to try it out.',
  },
  {
    Mock: MockResults,
    title: 'Step 5 — Download your results',
    body: 'Once payment is confirmed, processing begins automatically. Processing time depends on file size — a few hundred records may complete in minutes, while larger files of thousands of records will take longer. You\'ll be able to download results right from your Dashboard.',
  },
  {
    Mock: MockMasterFile,
    title: 'Step 6 — Your Master File grows over time',
    body: 'Every upload builds your enriched master database. Track quality scores, enrichment coverage by category, and drill into any group of records.',
  },
  {
    Mock: MockCTA,
    title: "You're ready to go",
    body: '',
  },
];
